import React, { useState, useEffect } from "react";

function PaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      setError(null);

      const API_BASE_URL =
        process.env.REACT_APP_API_BASE_URL || "https://installmentzone.com/api";
      const apiUrl = `${API_BASE_URL}/payments/payments.php`;

      const response = await fetch(apiUrl);
      const responseText = await response.text();

      if (!response.ok) throw new Error(`HTTP error: ${response.status}`);

      const result = JSON.parse(responseText);
      if (result.success) {
        setPayments(Array.isArray(result.data) ? result.data : []);
      } else {
        setError(result.error || "API error");
      }
    } catch (err) {
      setError(err.message || "Error fetching payments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  const handleRetry = () => fetchPayments();

  if (loading)
    return <p style={{ color: "#fff", textAlign: "center" }}>Loading payments...</p>;

  if (error) {
    return (
      <div
        style={{
          padding: "20px",
          margin: "20px auto",
          background: "rgba(255, 255, 255, 0.1)",
          border: "1px solid red",
          borderRadius: "10px",
          maxWidth: "800px",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <h3 style={{ color: "#F87171" }}>Error Fetching Payments</h3>
        <p style={{ whiteSpace: "pre-wrap" }}>
          <strong>Details:</strong> {error}
        </p>
        <button
          onClick={handleRetry}
          style={{
            padding: "10px 20px",
            marginTop: "10px",
            background: "#1E3A8A",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
        fontFamily: "Segoe UI, sans-serif",
        color: "#fff",
        overflowY: "auto", // ✅ stable scroll container
        WebkitOverflowScrolling: "touch",
        scrollBehavior: "smooth",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.15)",
          padding: "30px",
          borderRadius: "15px",
          maxWidth: "1000px",
          margin: "0 auto",
          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
          backdropFilter: "none", // ✅ remove blur to stop re-render shake
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "28px",
            fontWeight: "600",
            marginBottom: "25px",
          }}
        >
          Payments Management
        </h2>

        {payments.length === 0 ? (
          <p style={{ textAlign: "center" }}>No payments found.</p>
        ) : (
          <div style={{ overflowX: "auto", willChange: "transform" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                background: "rgba(255, 255, 255, 0.9)",
                borderRadius: "10px",
                overflow: "hidden",
                color: "#1E293B",
                tableLayout: "fixed",
              }}
            >
              <thead>
                <tr style={{ background: "#1E3A8A", color: "#fff" }}>
                  <th style={{ padding: "14px", textAlign: "left" }}>ID</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Customer Name</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Amount</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Date</th>
                  <th style={{ padding: "14px", textAlign: "left" }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {payments.map((payment, index) => (
                  <tr
                    key={payment.id || index}
                    style={{
                      background: index % 2 === 0 ? "#F8FAFC" : "#FFFFFF",
                      borderBottom: "1px solid #E5E7EB",
                      transition: "background 0.2s ease",
                    }}
                  >
                    <td style={{ padding: "12px" }}>{payment.id}</td>
                    <td style={{ padding: "12px" }}>{payment.customer_name || "N/A"}</td>
                    <td
                      style={{
                        padding: "12px",
                        color: "#0F766E",
                        fontWeight: "500",
                      }}
                    >
                      {payment.amount
                        ? `GH₵${parseFloat(String(payment.amount).replace(/,/g, "")).toLocaleString(
                            "en-GH",
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )}`
                        : "N/A"}
                    </td>
                    <td style={{ padding: "12px" }}>
                      {payment.date ? new Date(payment.date).toLocaleString() : "N/A"}
                    </td>
                    <td
                      style={{
                        padding: "12px",
                        fontWeight: "600",
                        color:
                          payment.status?.toLowerCase() === "paid"
                            ? "#16A34A"
                            : payment.status?.toLowerCase() === "pending"
                            ? "#CA8A04"
                            : "#DC2626",
                      }}
                    >
                      {payment.status || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default PaymentsPage;
